import {AutogenLayoutMarketExprtChargeCodesPanel} from "./autogen/AutogenLayoutMarketExprtChargeCodesPanel";

export class MarketExprtChargeCodesPanel extends AutogenLayoutMarketExprtChargeCodesPanel{


}
